import { useCallback, useEffect, useState } from "react";
import {
  useDbtDocsCollaborationSelector,
  useDbtDocsCollaborationDispatch,
} from "../collaboration/DbtDocsCollaborationProvider";
import HotspotButton from "../collaboration/HotspotButton";
import {
  getCodeBlockElementInPage,
  getModelPartsFromLocationHash,
} from "../collaboration/highlightUtils";
import { Manifest, updateNewConversation } from "../collaboration/DbtDocsReducer";
import { ConversationGroup } from "../collaboration/conversations/context/types";

const AddCommentOnCodeButton = () => {
  const dispatch = useDbtDocsCollaborationDispatch();
  const codeBlockUpdated = useDbtDocsCollaborationSelector(
    state => state.codeblockLoaded
  ) as boolean;
  const manifest = useDbtDocsCollaborationSelector(state => state.manifest) as Manifest;
  const [lineNumber, setLineNumber] = useState(0);
  const codeElement = getCodeBlockElementInPage()?.parentElement;

  const handleClick = () => {
    if (!codeElement || !manifest.nodes) {
      return;
    }
    const modelParts = getModelPartsFromLocationHash();
    if (!modelParts || modelParts.length < 3) {
      console.error("Unable to find model parts", modelParts);
      return;
    }
    const code = manifest.nodes[modelParts[2]]?.raw_code;
    const data = {
      highlight: code.split("\n")[lineNumber],
      range: {
        end: { line: lineNumber, character: 0 },
        start: { line: lineNumber, character: 0 },
      },
    } as unknown as ConversationGroup["meta"];

    dispatch(updateNewConversation({ meta: data }));
  };

  const onMouseMove = useCallback(
    (e: MouseEvent) => {
      if (!codeElement) {
        return;
      }
      const endY = e.y;
      const lineNumbers = codeElement.querySelectorAll(`.line-numbers-rows > span`);
      const end = Array.from(lineNumbers).findIndex(node => {
        const { height, y } = node.getBoundingClientRect();
        return endY >= y && endY <= y + height;
      });
      setLineNumber(end);
    },
    [codeElement]
  );

  useEffect(() => {
    if (!codeBlockUpdated || !codeElement) {
      return;
    }

    codeElement.addEventListener("mousemove", onMouseMove);

    return () => {
      codeElement.removeEventListener("mousemove", onMouseMove);
    };
  }, [codeBlockUpdated, codeElement, onMouseMove]);

  if (!codeBlockUpdated || !codeElement) {
    return null;
  }
  return (
    <HotspotButton target={codeElement} onClick={handleClick} style={{ top: lineNumber * 21.2 }} />
  );
};

export default AddCommentOnCodeButton;
